import axios from '@/axios'

export default {
  fetchAll(params){
    return axios.get(`/reasons/all`, {params})
  },
  fetchLimit(params){
    return axios.get(`/reasons`, {params})
  },  
  fetchById(id){
    return axios.get(`/reasons/${id}`)
  },    
  create(payload){
    return axios.post(`/reasons`, payload)
  },
  update(id, payload){
    return axios.put(`/reasons/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/reasons/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/reasons`, payload)
  },
  fetchDataOptions(params){
    return axios.get(`/reasons/options`, {params})
  }   
}